export const UPDATE_ABOUT_US = 'aboutUs/UPDATE_ABOUT_US'
